import { render } from "./edit.vue?vue&type=template&id=0f2d2bbd&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=0f2d2bbd&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2d2bbd"],['__file',"src/views/chess/section/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f2d2bbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f2d2bbd', __exports__)) {
    console.log('reload')
    api.reload('0f2d2bbd', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=0f2d2bbd&scoped=true", () => {
    console.log('re-render')
    api.rerender('0f2d2bbd', render)
  })

}


export default __exports__